export const partnerSkinEnums = {
  pg: 0,
  topc: 1,
  vbet: 2,
  bfth: 3,
  limonBet: 4,
  ebets: 5,
  pbets: 6,
  vbetam: 7,
};

export const partnerSkinNames = {
  0: 'pg',
  1: 'topc',
  2: 'vbet',
  3: 'bfth',
  4: 'limonBet',
  5: 'ebets',
  6: 'pbets',
  7: 'vbetam',
};

export const partnerSkinConfigs = {
  pg: {
    hasLoader: false,
  },
  topc: {
    hasLoader: true,
  },
  vbet: {
    hasLoader: true,
  },
  bfth: {
    hasLoader: true,
  },
  limonBet: {
    hasLoader: false,
  },
  ebets: {
    hasLoader: false,
  },
  pbets: {
    hasLoader: false,
  },
  vbetam: {
    hasLoader: false,
  },
};
